// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dateRangePicker {
  display: inline-block;
}
.dateRangePicker .vc-container {
  font-family: var(--font-family);
}
.dateRangePicker .quickRanges {
  padding: 5px 0;
}
.dateRangePicker .quickRanges .quickOptions {
  margin-bottom: 5px;
}
.dateRangePicker .quickRanges .quickOptions .quickOption {
  padding: 5px;
  text-align: center;
  cursor: pointer;
}
.dateRangePicker .quickRanges .quickOptions .quickOption:hover {
  background-color: #ECF0F5;
}
.dateRangePicker .quickRanges .quickOptions .quickOption.selected {
  background-color: var(--default-color);
  color: white;
}
.dateRangePicker .quickRanges .btn {
  width: 100%;
}
.dateRangePicker .customRange {
  padding: 10px;
}
.dateRangePicker .customRange .vc-container {
  border: none;
}
.dateRangePicker .customRange .customRangeFooter {
  width: 500px;
}
.dateRangePicker .customRange .customRangeFooter .backToQuickLink {
  color: var(--default-color);
  width: calc(50% - 10px);
  text-align: center;
  display: inline-block;
  cursor: pointer;
}
.dateRangePicker .customRange .customRangeFooter .backToQuickLink:hover {
  text-decoration: underline;
}
.dateRangePicker .customRange .customRangeFooter .btn {
  width: calc(50% - 30px);
  margin-left: 30px;
}`, "",{"version":3,"sources":["webpack://./js/vueComponents/dateRangePicker/src/dateRangePicker.vue","webpack://./dateRangePicker.vue"],"names":[],"mappings":"AAGA;EACE,qBAAA;ACFF;ADGE;EACE,+BAAA;ACDJ;ADGE;EACE,cAAA;ACDJ;ADEI;EACE,kBAAA;ACAN;ADCM;EACE,YAAA;EACA,kBAAA;EACA,eAAA;ACCR;ADAQ;EACE,yBAhBG;ACkBb;ADAQ;EACE,sCAlBM;EAmBN,YAAA;ACEV;ADEI;EACE,WAAA;ACAN;ADGE;EACE,aAAA;ACDJ;ADEI;EACE,YAAA;ACAN;ADEI;EACE,YAAA;ACAN;ADCM;EACE,2BAAA;EACA,uBAAA;EACA,kBAAA;EACA,qBAAA;EACA,eAAA;ACCR;ADAQ;EACE,0BAAA;ACEV;ADCM;EACE,uBAAA;EACA,iBAAA;ACCR","sourcesContent":["\n$hoverColor: #ECF0F5;\n$selectedColor: var(--default-color);\n.dateRangePicker {\n  display: inline-block;\n  .vc-container {\n    font-family: var(--font-family);\n  }\n  .quickRanges {\n    padding: 5px 0;\n    .quickOptions {\n      margin-bottom: 5px;\n      .quickOption {\n        padding: 5px;\n        text-align: center;\n        cursor: pointer;\n        &:hover {\n          background-color: $hoverColor;\n        }\n        &.selected {\n          background-color: $selectedColor;\n          color: white;\n        }\n      }\n    }\n    .btn {\n      width: 100%;\n    }\n  }\n  .customRange {\n    padding: 10px;\n    .vc-container {\n      border: none;\n    }\n    .customRangeFooter {\n      width: 500px;\n      .backToQuickLink {\n        color: var(--default-color);\n        width: calc(50% - 10px);\n        text-align: center;\n        display: inline-block;\n        cursor: pointer;\n        &:hover {\n          text-decoration: underline;\n        }\n      }\n      .btn {\n        width: calc(50% - 30px);\n        margin-left: 30px;\n      }\n    }\n  }\n}\n",".dateRangePicker {\n  display: inline-block;\n}\n.dateRangePicker .vc-container {\n  font-family: var(--font-family);\n}\n.dateRangePicker .quickRanges {\n  padding: 5px 0;\n}\n.dateRangePicker .quickRanges .quickOptions {\n  margin-bottom: 5px;\n}\n.dateRangePicker .quickRanges .quickOptions .quickOption {\n  padding: 5px;\n  text-align: center;\n  cursor: pointer;\n}\n.dateRangePicker .quickRanges .quickOptions .quickOption:hover {\n  background-color: #ECF0F5;\n}\n.dateRangePicker .quickRanges .quickOptions .quickOption.selected {\n  background-color: var(--default-color);\n  color: white;\n}\n.dateRangePicker .quickRanges .btn {\n  width: 100%;\n}\n.dateRangePicker .customRange {\n  padding: 10px;\n}\n.dateRangePicker .customRange .vc-container {\n  border: none;\n}\n.dateRangePicker .customRange .customRangeFooter {\n  width: 500px;\n}\n.dateRangePicker .customRange .customRangeFooter .backToQuickLink {\n  color: var(--default-color);\n  width: calc(50% - 10px);\n  text-align: center;\n  display: inline-block;\n  cursor: pointer;\n}\n.dateRangePicker .customRange .customRangeFooter .backToQuickLink:hover {\n  text-decoration: underline;\n}\n.dateRangePicker .customRange .customRangeFooter .btn {\n  width: calc(50% - 30px);\n  margin-left: 30px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
